import { GLOBAL_API_CLIENT } from "@/modules/api/globalApiClient";
import { electronModule } from "@/modules/electron";
import { getAudioRecordingIdFromDesktopAudioArtifactRef } from "@/modules/electron/desktop-audio-artifact-ref";
import { DesktopAudioUploadProgressEvent, DesktopAudioArtifactRef } from "@/modules/electron/types";
import {
  AudioUploadTransport,
  AudioUploadTransportInput,
  UploadTransportResult,
} from "@/store/audio/uploading/audio-uploading.types";

export class ElectronAudioUploadTransport implements AudioUploadTransport<DesktopAudioArtifactRef> {
  async upload({
    source,
    uploadMeta,
    forceRestart,
    onProgress,
  }: AudioUploadTransportInput<DesktopAudioArtifactRef>): Promise<UploadTransportResult> {
    const audioRecordingId = getAudioRecordingIdFromDesktopAudioArtifactRef({
      artifactRef: source,
    });

    const authToken = GLOBAL_API_CLIENT.getAuthToken();
    if (!authToken) {
      return {
        success: false,
        error: "No auth token available",
      };
    }

    const unsubscribe = await electronModule.audioUpload.onProgress?.({
      callback: (payload: DesktopAudioUploadProgressEvent) => {
        if (payload.audioRecordingId !== audioRecordingId) {
          return;
        }

        onProgress({
          progressPercent: payload.progressPercent,
        });
      },
    });

    try {
      return await electronModule.audioUpload.startAudioUpload({
        artifactRef: source,
        uploadMeta,
        authToken,
        forceRestart,
      });
    } finally {
      unsubscribe?.();
    }
  }
}
